import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core"
import { FormBuilder, FormGroup } from "@angular/forms"
import { IconImageService } from "@shared/services/icon-image.service"
import { LabelValue } from "../ag-drop-down.component"
import { AgColor, AgSecondaryColor } from "@shared/components/ag-label/ag-label.component"

@Component({
  selector: "ag-single-sublabel-box",
  templateUrl: "./ag-single-sublabel-box.component.html",
  styleUrls: ["./ag-single-sublabel-box.component.scss"],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgSingleSubLabelBoxComponent implements OnInit {
    /*This component was added to be able to add optional text to the right in the drop down
        LabelValue have received an optional "subLabel" variable for this.
    */
  @Input() list: LabelValue[] = []
  @Input() disabledInputs: LabelValue[] = []
  @Input() showBox = false
  @Input() showSearchField = true
  @Input() useFixedPosition = false
  @Input() showHeaders: boolean = false
  @Input() maxHeight: number = 1000
  @Input() currentValue: LabelValue
//   @Input() checkboxType: checkboxType = "square" //Not used yet, only design for circle
  @Input() withHoverEffect: boolean = false
  @Input() subLabelColor: AgColor = 'Info' //Added for this component
  @Input() subLabelSecondaryColor: AgSecondaryColor = 'Standard' //Added for this component

  @Output() output = new EventEmitter<LabelValue>()
  @Output() searchBoxFieldClicked = new EventEmitter<boolean>()

  @ViewChild("inputField", { static: false }) inputField: ElementRef

  public displayedList: LabelValue[] = []
  public searchForm: FormGroup
  public isTyping = false

  constructor(
    private fb: FormBuilder,
    public iconService: IconImageService,
  ) {}

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      searchInput: [""],
    })
    this.displayedList = this.list
  }

  onInputChange(value: string) {
    if (value === "") {
      this.isTyping = false
      this.displayedList = this.list
    } else {
      this.isTyping = true
      this.displayedList = this.list.filter((x) => x.label.toLowerCase().includes(value.toLowerCase()))
    }
  }

  showBoxClicked() {
    if (!this.isTyping || (this.inputField && this.inputField.nativeElement && this.inputField.nativeElement.value === "")) {
      this.displayedList = this.list
    }
    return true
  }

  onItemClicked(item: LabelValue) {
    const disabledItem = this.disabledInputs.some((disabled) => disabled.label === item.label)
    if (!disabledItem && item.label !== this.currentValue?.label && item.value !== "search-box-title") {
      this.currentValue = item
      this.output.emit(item)
      this.showBox = false
    }
  }

  onFieldClicked() {
    this.showBox = false
    this.searchBoxFieldClicked.emit(true)
  }

  public checkSelectedItems(item: LabelValue): boolean {
    return this.currentValue?.label === item?.label
  }

  isItemDisabled(label: string): boolean {
    const itemDisabled = this.displayedList.some((disabled) => !this.disabledInputs.some((di) => di.label === disabled.label))
    if (itemDisabled) {
      return this.disabledInputs.some((item) => item.label === label)
    }
    return false
  }

  showDivider(item: LabelValue) {
    return item.value === "search-box-title" && item.label !== this.displayedList[0].label
  }

  trackByFn(index: number, item: any): any {
    return item.value
  }
}
